(() => {
  const MIN_TOTAL_CENTS = 3500;
  const MAX_TOTAL_CENTS = 150000;

  function formatEuro(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);
  }

  function installStyles() {
    if (document.getElementById('rdsn-klarna-styles')) return;

    const style = document.createElement('style');
    style.id = 'rdsn-klarna-styles';
    style.textContent = `
      .rdsn-klarna {
        margin-top: 12px;
        text-align: center;
        color: #111;
        font-size: 11px;
        line-height: 1.35;
      }

      .rdsn-klarna__line {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 3px;
      }

      .rdsn-klarna__amount,
      .rdsn-klarna__brand {
        font-weight: 700;
      }

      .rdsn-klarna__brand {
        font-size: 12px;
        letter-spacing: -0.03em;
        margin-left: 1px;
      }

      .rdsn-klarna__more {
        appearance: none;
        border: 0;
        background: transparent;
        padding: 0;
        margin-left: 1px;
        color: inherit;
        font: inherit;
        text-decoration: underline;
        text-underline-offset: 2px;
        cursor: pointer;
      }

      .rdsn-klarna__info {
        max-width: 440px;
        margin: 6px auto 0;
        color: rgba(17, 17, 17, 0.68);
        font-size: 10px;
        line-height: 1.4;
      }

      @media (max-width: 749px) {
        .rdsn-klarna {
          margin-top: 10px;
          padding-inline: 4px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function setupKlarnaMessage(root = document) {
    const scope = root.matches?.('.rp') ? root : root.querySelector?.('.rp') || document.querySelector('.rp');
    if (!scope || scope.querySelector('[data-rdsn-klarna]')) return;

    const sectionRoot = scope.closest('.shopify-section') || document;
    const addToCart = scope.querySelector('add-to-cart-component');
    const form = addToCart?.closest('form');
    const variantsNode = sectionRoot.querySelector('[data-rp-variants]');
    const hiddenVariantId = form?.querySelector('[data-rp-id]');

    if (!addToCart || !form || !variantsNode || !hiddenVariantId) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent || '[]');
    } catch (error) {
      return;
    }

    const message = document.createElement('div');
    message.className = 'rdsn-klarna';
    message.setAttribute('data-rdsn-klarna', '');
    message.innerHTML = `
      <div class="rdsn-klarna__line">
        <span>3 paiements de <strong class="rdsn-klarna__amount" data-rdsn-klarna-amount></strong> à 0 % d’intérêt avec</span>
        <span class="rdsn-klarna__brand" aria-label="Klarna">Klarna</span>
        <button class="rdsn-klarna__more" type="button" aria-expanded="false">En savoir plus</button>
      </div>
      <div class="rdsn-klarna__info" data-rdsn-klarna-info hidden>
        Paiement en 3 fois proposé par Klarna, sous réserve d’éligibilité. Les modalités définitives sont affichées lors du paiement.
      </div>
    `;

    addToCart.insertAdjacentElement('afterend', message);

    const amount = message.querySelector('[data-rdsn-klarna-amount]');
    const info = message.querySelector('[data-rdsn-klarna-info]');
    const more = message.querySelector('.rdsn-klarna__more');

    more?.addEventListener('click', () => {
      const willOpen = info.hidden;
      info.hidden = !willOpen;
      more.setAttribute('aria-expanded', String(willOpen));
    });

    function update() {
      const variant = variants.find((item) => String(item.id) === String(hiddenVariantId.value)) || variants[0];
      const visibleQtyInput = scope.querySelector('[data-rp-qty]');
      const quantity = Math.max(1, Number.parseInt(visibleQtyInput?.value || '1', 10) || 1);
      const total = Number(variant?.price || 0) * quantity;

      if (!variant || !variant.available || total < MIN_TOTAL_CENTS || total > MAX_TOTAL_CENTS) {
        message.hidden = true;
        return;
      }

      message.hidden = false;
      amount.textContent = formatEuro(total / 3);
    }

    update();

    const scheduleUpdate = () => window.requestAnimationFrame(update);
    scope.addEventListener('change', scheduleUpdate);
    scope.addEventListener('input', scheduleUpdate);
    scope.addEventListener('click', scheduleUpdate);
  }

  installStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupKlarnaMessage());
  } else {
    setupKlarnaMessage();
  }

  document.addEventListener('shopify:section:load', (event) => setupKlarnaMessage(event.target));
})();
